// extracted by mini-css-extract-plugin
export var label = "_c4-5";
export var slideContainer = "_c4-0";
export var slider = "_c4-1";
export var sliderLg = "_c4-4";
export var sliderMd = "_c4-3";
export var sliderSm = "_c4-2";